import { Grid } from "@mui/material";
import classNames from "classnames/bind";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import PosPopUp from "../../components/PosPopUp";
import styles from "./index.module.css";

function MemberCard({ memberData, positions, onInvite, refresh }) {
  const cx = classNames.bind(styles);
  const [toggle, setToggle] = useState(false);
  const handleGoToUrl = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  // memberData.igLink = memberData.igLink ? memberData.igLink : "";
  // memberData.linkedIdLink = memberData.linkedIdLink ? memberData.linkedIdLink : "";
  // memberData.fbLink = memberData.fbLink ? memberData.fbLink : "";
  return (
    <div className={cx("user-card-base")}>
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="center"
      >
        <div className={cx("user-card")}>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Link
              to={{ pathname: "/Profile_show", state: { id: memberData.id } }}
            >
              <img
                className={cx("user-avatar")}
                alt="avatar"
                src={memberData.img}
              />
            </Link>
            <span className={cx("user-name")}>
              {memberData.name}
            </span>
            <span className={cx("user-des")}>{memberData.motivation ? memberData.motivation : <br />}</span>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <div
                className={cx("ig-btn")}
                style={{
                  pointerEvents: !memberData.igLink && "none"
                }}
                onClick={() => handleGoToUrl(memberData.igLink)}
              />
              <div
                className={cx("linkin-btn")}
                style={{
                  pointerEvents: !memberData.linkedInLink && "none"
                }}
                onClick={() => handleGoToUrl(memberData.linkedInLink)}
              />
              <div
                className={cx("fb-btn")}
                style={{
                  pointerEvents: !memberData.fbLink && "none"
                }}
                onClick={() => handleGoToUrl(memberData.fbLink)}
              />
            </Grid>
          </Grid>
        </div>
        <button disabled={memberData.inTeam} className={cx("invite-btn")} onClick={() => { setToggle(!toggle); }}>
          <span className={cx("invite-btn-font")}>邀請</span>
        </button>
        {toggle ? (<PosPopUp ocpPos={positions} handleInvite={onInvite} cancel={() => { setToggle(!toggle); refresh(); }} />) : null}
      </Grid>
    </div>
  );
}
export default MemberCard;

// <div className={cx('user-card')}>
// <Grid
//   container
//   direction="column"
//   justifyContent="flex-start"
//   alignItems="center"
// >
//   <img
//     className={cx('user-avatar')}
//     alt="avatar"
//     src={memberData.avatar_url}
//   />
//   <span className={cx('user-name')}>
//     {memberData.first_name} {memberData.last_name}
//   </span>
//   <span className={cx('user-des')}>{memberData.des}</span>
//   <Grid
//     container
//     direction="row"
//     justifyContent="center"
//     alignItems="center"
//   >
//     <div
//       className={cx('ig-btn')}
//       onClick={() => handleGoToUrl(memberData.ig_link)}
//     />
//     <div
//       className={cx('linkin-btn')}
//       onClick={() => handleGoToUrl(memberData.linkin_link)}
//     />
//     <div
//       className={cx('tiktok-btn')}
//       onClick={() => handleGoToUrl(memberData.tiktok_link)}
//     />
//   </Grid>
// </Grid>
// </div>
